<template>
  <v-dialog v-model="dialog" fullscreen scrollable lazy hide-overlay>
    <v-card>
      <v-toolbar color="primary" dark tabs>
        <!-- <v-toolbar-title>{{simplified.name}}</v-toolbar-title> -->
        <v-tabs v-model="tab" color="primary" slider-color="white" centered>
          <v-tab>{{ $tc('models.match') }}</v-tab>
          <v-tab :disabled="!match.homeTeamId">
            {{ $tc('titles.global.homeTeamLineUp') }}
          </v-tab>
          <v-tab :disabled="!match.visitorTeamId">
            {{ $tc('titles.global.visitorTeamLineUp') }}
          </v-tab>
          <v-tab :disabled="!simplified._id">
            {{ $tc('models.event', 2) }}
          </v-tab>
        </v-tabs>
        <v-spacer />
        <v-btn
          v-if="simplified._id"
          icon
          dark
          :loading="$store.state.matches.loading"
          @click="$store.dispatch('matches/fetchSimplified', simplified._id)"
        >
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn dark icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-progress-linear
          :active="loadingItem"
          height="3"
          :indeterminate="true"
          class="my-1"
        />
        <form-loader v-if="loadingItem" />
        <v-tabs-items v-else v-model="tab">
          <v-tab-item ripple>
            <tab-view :match="match" />
          </v-tab-item>
          <v-tab-item ripple>
            <team-line-up
              v-if="simplified._id && simplified.homeTeamId"
              ref="tabHomeTeamLineUp"
              :match-id="simplified._id"
              :team-id="simplified.homeTeamId._id"
              team-type="home"
              :edit="false"
            />
          </v-tab-item>
          <v-tab-item ripple>
            <team-line-up
              v-if="simplified._id && simplified.visitorTeamId"
              ref="tabVisitorTeamLineUp"
              :match-id="simplified._id"
              :team-id="simplified.visitorTeamId._id"
              team-type="visitor"
              :edit="false"
            />
          </v-tab-item>
          <v-tab-item ripple>
            <tab-events
              :match-id="simplified._id"
              :home-team-id="
                simplified.homeTeamId ? simplified.homeTeamId._id : ''
              "
              :visitor-team-id="
                simplified.visitorTeamId ? simplified.visitorTeamId._id : ''
              "
              :location="simplified.location ? simplified.location._id : ''"
              :video="video"
              type-view="view"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <!-- <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <meta-button @click="cancel" type="cancel" />
      </v-card-actions>-->
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import TabEvents from './TabEvents'
import TeamLineUp from './components/TeamLineUp'
import TabView from './view/TabView'

export default {
  name: 'MatchView',
  components: {
    TabView,
    TabEvents,
    TeamLineUp,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tab: 0,
      match: {},
      homeTeamPlayers: [],
      homeTeamLineUp: [],
      visitorTeamPlayers: [],
      visitorTeamLineUp: [],
      dialog: false,
      loadingItem: false,
    }
  },
  watch: {
    simplified: {
      handler: function (val) {
        if (val) {
          this.setObject(val)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.dialog = true
    if (this.id) {
      this.nextTick(() => {
        this.loadingItem = true
        this.fetchSimplified(this.id)
          .then(() => {
            if (this.$route.params.tab) this.tab = this.$route.params.tab
          })
          .finally(() => {
            this.loadingItem = false
          })
          .catch(() => this.cancel())
      })
    }
  },
  watch: {
    simplified: {
      handler: function (val) {
        if (val) {
          this.setObject(val)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapState({
      simplified: (state) => state.matches.simplified,
      video: (state) => state.matches.video,
    }),
    ...mapGetters({
      teamPositions: 'teams/teamPositions',
      matchTypes: 'matches/matchTypes',
    }),
  },
  methods: {
    ...mapActions({
      fetchSimplified: 'matches/fetchSimplified',
      reset: 'matches/reset',
      getOneTeam: 'teams/getOne',
      fetchUserSelect: 'users/fetchSelectList',
    }),
    setObject(match) {
      this.match = { ...match }

      // let wtzDate = getWtzDate(match)
      // if (match.date && moment(match.date).isValid()) {
      //   this.match.date = wtzDate.format('DD-MMM-YYYY')
      // }
      // if (match.time && moment(match.time, 'HH:mm').isValid()) {
      //   this.match.time = wtzDate.format('h:mm a')
      // }

      let type = this.matchTypes.find((item) => item.value === match.type)
      this.match.type = type ? type.text : '-'

      if (match.homeTeamId && match.homeTeamId._id) {
        this.setHomeTeamLineUp(match.homeTeamLineUp)
        this.setHomeTeamPlayers(match.homeTeamId)
      }
      if (match.visitorTeamId && match.visitorTeamId._id) {
        this.setVisitorTeamLineUp(match.visitorTeamLineUp)
        this.setVisitorTeamPlayers(match.visitorTeamId)
      }
      if (this.match.homeTeamId || this.match.visitorTeamId) {
        let params = {
          _id: [],
        }
        if (this.match.homeTeamId) params._id.push(this.match.homeTeamId._id)
        if (this.match.visitorTeamId) {
          params._id.push(this.match.visitorTeamId._id)
        }
        this.$store.dispatch('teams/fetchSelectList', params)
      }
    },

    setHomeTeamLineUp(lineUp) {
      this.homeTeamLineUp = []
      if (lineUp) {
        this.homeTeamLineUp = lineUp.map((item) => {
          let result = {
            userId: item.userId,
            dorsal: item.dorsal,
          }
          const position = this.teamPositions.find(
            (pos) => pos.value === item.position
          )
          result.position = position ? position.text : '-'
          return result
        })
      }
    },
    setVisitorTeamLineUp(lineUp) {
      this.visitorTeamLineUp = []
      if (lineUp) {
        this.visitorTeamLineUp = lineUp.map((item) => {
          let result = {
            userId: item.userId,
            dorsal: item.dorsal,
          }
          const position = this.teamPositions.find(
            (pos) => pos.value === item.position
          )
          result.position = position ? position.text : '-'
          return result
        })
      }
    },
    setHomeTeamPlayers(team) {
      this.homeTeamPlayers = []
      if (team && team._id) {
        this.fetchUserSelect({
          team: team._id,
          typeRole: 'player',
          set: false,
        }).then((list) => {
          list.forEach((item) => this.homeTeamPlayers.push(item))
        })
      }
    },
    setVisitorTeamPlayers(team) {
      this.visitorTeamPlayers = []
      if (team && team._id) {
        this.fetchUserSelect({
          team: team._id,
          typeRole: 'player',
          set: false,
        }).then((list) => {
          list.forEach((item) => this.visitorTeamPlayers.push(item))
        })
      }
    },
    clear() {
      this.tab = 0
      this.match = {}
      this.simplified = {}
      this.homeTeamPlayers = []
      this.homeTeamLineUp = []
      this.visitorTeamPlayers = []
      this.visitorTeamLineUp = []
      this.reset()
    },
    cancel() {
      if (this.dialog) this.dialog = false
      const vm = this
      setTimeout(() => {
        vm.clear()
        if (vm.from && vm.from.name) vm.$router.push(vm.from)
        else vm.$router.push('/')
      }, 150)
    },
  },
}
</script>
